import React, { useContext } from 'react'
import { IframeContext } from '~/service/IframeConn'

type CustomLinkProps = {
  link: CustomLink
  className: string
}

export const CustomLink: React.FC<CustomLinkProps> = ({ link, className }) => {
  const { parentRef } = useContext(IframeContext)

  const openInBackground = link.openInBackground && window.isIframe

  const onClick =
    (aux: boolean) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      if (openInBackground) {
        e.preventDefault()

        parentRef.current?.goToURL(link, aux)
      }
    }

  return (
    <a
      className={className}
      href={link.url}
      target={openInBackground ? undefined : '_blank'}
      onClick={onClick(false)}
      onAuxClick={onClick(true)}
    >
      <span className="icon is-small">
        <span className={link.icon ? 'far fa-' + link.icon : 'far fa-link'} />
      </span>
      <span>{link.name}</span>
    </a>
  )
}
